import './hto-appointment-location.scss';
import React, { useEffect, useState, useRef } from 'react';
import config from '../../../../config';
import { connect } from 'react-redux';
// actions & helper
import { getLocationServiceDetails } from '../../../../actionCreators/hto';
import { getPincodeData } from '../../../../actionCreators/address';
import { applyCode } from '../../../../actionCreators/cart';
// components
import GoogleLocation from '../../../GoogleLocation/GoogleLocation';
import localStorageHelper from '../../../../utils/localStorageHelper';

let appointmentType;

function HTOAppointmentLocation(props) {

    const [appointment, setAppointment] = useState();
    const [center, setCenter] = useState();

    useEffect(() => {
        const data = localStorageHelper.getItem('htoAddress');
        setAppointment({ bookNow: data.bookNow, bookLater: data.bookLater, address: data.formattedAddress });
        setCenter({ lat: data.lat, lng: data.lng });
        return () => { appointmentType = undefined; };
    }, []);

    useEffect(() => {
        if (!(props.cartData.cartId && appointmentType)) return;
        /* if (appointmentType === 'bookNow') {
            props.navTo('book-now');
            return;
        } */
        const discounts = props.cartData.totals.discounts;
        if (discounts) {
            const coupon = discounts.find(d => d.type === 'gv');
            if (!coupon && appointmentType === 'bookLater') props.applyCoupon(props.couponCode);
        }
        props.navTo('book-later');
    }, [props.cartData]);

    const prevLocationServiceDetails = useRef(props.locationServiceDetails);
    useEffect(() => {
        if (prevLocationServiceDetails && props.locationServiceDetails && props.locationServiceDetails) {
            const data = localStorageHelper.getItem('htoAddress');
            const address = { ...data, ...props.locationServiceDetails };
            localStorageHelper.setItem('htoAddress', address);
            setAppointment({ bookNow: address.bookNow, bookLater: address.bookLater, address: address.formattedAddress });
        }
    }, [props.locationServiceDetails]);

    const onChangeAddress = address => {
        if ((!address.state || !address.city) && address.postcode) {
            props.getPincodeData(address.postcode);
        }
        const data = localStorageHelper.getItem('htoAddress');
        appointmentType = undefined;
        localStorageHelper.setItem('appointmentType', '');
        localStorageHelper.setItem('htoAddress', { ...data, ...address });
        if (address.lat && address.lng) props.getLocationServiceDetails(address.lat, address.lng);
    };

    const schedule = type => {
        appointmentType = type;
        localStorageHelper.setItem('appointmentType', appointmentType);
        props.scheduleOrUpdate(type);
    };

    const { bookNow, bookLater, address } = appointment || {}; // bookNow = { estimatedTime: 10, enable: true }
    return (
        <div className="appointment-location pd-r10 pd-l10 pd-b10 pd-t0">
            <GoogleLocation center={center} address={address} onChangeAddress={onChangeAddress} />
            <div className="text-color_brick_red fs10 fsp10">{typeof props.locationServiceDetails === 'undefined' ? 'We do not service at the given location, please try another location' : ''}</div>
            <div className="mr-t10 margin-t10"></div>
            {props.locationServiceDetails && <React.Fragment>
                {bookNow && bookNow.estimatedTime && <div className="hto-btn hto-btn__dark margin-t4 mr-t4">We are available in {bookNow.estimatedTime} minutes</div>}
                <div className="appointment-location__actions display-flex justify-content-center margin-t4 mr-t4">
                    {bookNow && <button onClick={() => schedule('bookNow')} className="hto-btn hto-btn__warn margin-r4 mr-r4">SCHEDULE FOR NOW</button>}
                    {bookLater && <button onClick={() => schedule('bookLater')} className="hto-btn hto-btn__primary">SCHEDULE FOR LATER</button>}
                </div>
                {appointment && !(bookNow || bookLater) && <div className="text-center text-color_brick_red margin-t4 mr-t4 fs14 fsp10">We dont provide the service at your location</div>}
            </React.Fragment>}
        </div>
    );
}

const mapStateToProps = state => ({
    cartData: state.cart.cartData.result,
    locationServiceDetails: state.hto.locationServiceableDetails
});

const mapDispatchToProps = dispatch => ({
    getPincodeData: pincode => dispatch(getPincodeData(pincode)),
    getLocationServiceDetails: (lat, lng) => dispatch(getLocationServiceDetails(lat, lng)),
    applyCoupon: code => dispatch(applyCode(`${config.apiPath.applyGV}${code}?applyWallet=false`, 'post')),
});

export default connect(mapStateToProps, mapDispatchToProps)(HTOAppointmentLocation);
